import React from 'react'
import PropTypes from 'prop-types'
import EnhancedTable from './main'

import ToDoConstant from 'constants/toDo'

/**
 * @extends {React.Component<{headRows:arrayOf(shape({label:string, width: number}>, rowTemplate:any, filas: any[]}
 */
class ClientSideTable extends React.PureComponent {
  render = () => {
    const { headRows, rowTemplate, filas } = this.props

    const validFilas = filas.filter(x => x.toDo !== ToDoConstant.ELIMINAR)

    return (
      <>
        <EnhancedTable headRows={headRows} rowTemplate={rowTemplate} filas={validFilas} />
      </>
    )
  }
}

ClientSideTable.propTypes = {
  headRows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ),
  rowTemplate: PropTypes.any,
  filas: PropTypes.array
}

export default ClientSideTable
